import type { SxStyle } from '@aibees/shared/theme';

export const logo: SxStyle = {
  width: 64,
  height: 64,
  justifyContent: 'center',
  alignItems: 'center',
};
